<div class="marker" [class.icon]="isCompleted()">
  @if (!isCompleted()) {
    <onyx-dot [color]="dotColor()" [pulse]="isInPoint()"></onyx-dot>
  } @else {
    <onyx-icon
      [class]="color()"
      name="check-circle-filled"
      [size]="16"
    ></onyx-icon>
  }
</div>

<div class="content">
  <div class="row {{ color() }}">
    {{ `${I18N}.inPoint` | translate }}

    <div class="wrapper">
      @if (isToDo() || (isCanceled() && !this.timestamps()?.arrivedAt)) {
        @if (serviceTime(); as serviceTime) {
          {{ 'labels.plan' | translate }} {{ serviceTime | duration }}
        } @else {
          -
        }
      } @else {
        @if (serviceTime(); as serviceTime) {
          <span class="f-body-xs">
            ({{ 'labels.plan' | translate | lowercase }}
            {{ serviceTime | duration }})
          </span>
        }

        @if (timestamps()?.arrivedAt; as arrivedAt) {
          <span>
            @if (isInPoint()) {
              {{ 'labels.from' | translate | lowercase }}
              {{ 'now' | diff: arrivedAt | async | duration }}
            } @else if (elapsedEnd(); as elapsedEnd) {
              {{ elapsedEnd | diff: arrivedAt | duration }}
            }
          </span>
        }
      }
    </div>
  </div>

  @if (timestamps()?.arrivedAt; as arrivedAt) {
    <ng-container
      *ngTemplateOutlet="
        statusRowTemplate;
        context: {
          pointStatus: OrderPointStatus.WAITING,
          start: arrivedAt,
          end: timestamps()?.startedAt,
        }
      "
    ></ng-container>
  }

  @if (timestamps()?.startedAt; as startedAt) {
    <ng-container
      *ngTemplateOutlet="
        statusRowTemplate;
        context: {
          pointStatus: OrderPointStatus.IN_PROGRESS,
          start: startedAt,
          end: elapsedEnd(),
        }
      "
    ></ng-container>
  }
</div>

<ng-template
  let-pointStatus="pointStatus"
  let-start="start"
  let-end="end"
  #statusRowTemplate
>
  <div class="row f-body-xs f-muted">
    {{ `${DictionaryCode.ORDER_POINT_STATUS}.${pointStatus}` | translate }}

    <div class="wrapper">
      @if (!driversStatuses().has(pointStatus)) {
        <onyx-icon
          class="f-muted"
          name="manual-outlined"
          [size]="12"
          [onyxTooltip]="`${I18N}.manualStatusHint`"
        ></onyx-icon>
      }

      @if (status() === pointStatus) {
        {{ 'labels.from' | translate | lowercase }}
        {{ start | onyxDate: 'time-date-dot' : { separator: ' · ' } }}
      } @else {
        {{
          start
            | onyxDate
              : 'time-date-dot'
              : {
                  endDate: end,
                  separator: ' · ',
                  showGap: false,
                }
        }}
      }
    </div>
  </div>
</ng-template>
